
import { Destination, DestinationOption } from './dataTypes'
import { AbuDhabiOptions, DubaiOptions, DefaultOptions, MaldivesOptions, MauritiusOptions, SeychellesOptions, SouthernAfricaOptions, SriLankaOptions } from './OptionsDataTypes'


export const initialDestinations : DestinationOption[] = [
    {   destination : Destination.AbuDhabi, 
        id : 1, 
        selected : false,
        options : AbuDhabiOptions
    },
    {   destination : Destination.Dubai, 
        id : 2, 
        selected : false,
        options : DubaiOptions
    },
    {   destination : Destination.Maldives, 
        id : 3, 
        selected : false,
        options : MaldivesOptions
    },
    {   destination : Destination.Mauritius, 
        id : 4, 
        selected : false,
        options : MauritiusOptions
    },
    {   destination : Destination.Seychelles, 
        id : 5, 
        selected : false,
        options: SeychellesOptions
    },
    {   destination : Destination.SouthernAfrica, 
        id : 6, 
        selected : false,
        options : SouthernAfricaOptions
    },
    {   destination : Destination.SriLanka, 
        id : 7, 
        selected : false,
        options : SriLankaOptions
    },
    {   destination : Destination.All, 
        id : 8, 
        selected : true,
        options : DefaultOptions,
    },
]
